import axios from './axiosConfig';
const BASE_URL = '/consumer';

export const login = async (data) => {
    const response = await axios.post('/auth/login', data);
    const token = response.data.token;
    if (token) {
        localStorage.setItem('Token', token);
    }
    return response;
};

export const getConsumers = async (page, limit) => {
    debugger;
    const response = await axios.get(`${BASE_URL}?page=${page}&limit=${limit}`);
    const { success, message, data } = response.data;

    if (success) {
        return data; // contains consumers, currentPage, totalItems, totalPages
    } else {
        throw new Error(message || 'Failed to fetch consumers');
    }
};

export const registerConsumer = async (data) => {
    debugger;
    const response = await axios.post(`${BASE_URL}/register`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const { success, message, data: resultData } = response.data;
    if (success) {
        return response.data;
    } else {
        throw new Error(message || 'Registration failed');
    }
};

export const updateConsumer = async (id, data) => {
    const response = await axios.put(`${BASE_URL}/update/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const { success, message, data: resultData } = response.data;
    if (success) {
        return response.data;
    } else {
        throw new Error(message || 'Update failed');
    }
};

export const deleteConsumer = (id, data) =>
    axios.delete(`${BASE_URL}/delete/${id}`, { data });

export const resetPassword = (payload) =>
    axios.post(`/user/reset-password`, payload);


export const openConsumerPdf = async (id, type) => {
    try {
        const response = await axios.get(`${BASE_URL}/pdf/${id}?type=${type}`, {
            responseType: 'blob',
        });

        const blob = response.data; // <-- axios gives blob here directly
        const contentDisposition = response.headers['content-disposition'];
        let filename = "download.pdf";

        // Extract filename if available
        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
                filename = match[1].replace(/['"]/g, '');
            }
        }

        // Create and trigger download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading PDF:", error);
        alert("Failed to download PDF");
    }
};


// export const openConsumerPdf = async (id, type) => {
//     try {
//         const response = await axios.get(`${BASE_URL}/pdf/${id}?type=${type}`, {
//             responseType: 'blob',
//         });

//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         const blobUrl = window.URL.createObjectURL(blob);

//         // Open PDF in the same tab
//         window.open(blobUrl, '_blank');

//         // Optional: revoke after delay (since navigation happens)
//         setTimeout(() => {
//             window.URL.revokeObjectURL(blobUrl);
//         }, 1000);
//     } catch (error) {
//         console.error('Error opening PDF:', error.message || error);
//         throw new Error('Failed to open PDF');
//     }
// };


// export const openConsumerPdf = async (id, type) => {
//     try {
//         const response = await axios.get(`${BASE_URL}/pdf/${id}?type=${type}`, {
//             responseType: 'blob',
//         });

//         const contentDisposition = response.headers['content-disposition'];
//         let filename = 'Document.pdf';
//         if (contentDisposition) {
//             const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//             if (match && match[1]) {
//                 filename = match[1].replace(/['"]/g, '');
//             }
//         }

//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         const url = window.URL.createObjectURL(blob);

//         const link = document.createElement('a');
//         link.href = url;
//         link.download = filename;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error('Error downloading PDF:', error.message || error);
//         throw new Error('Failed to download PDF');
//     }
// };
// import axios from './axiosConfig';

// const BASE_URL = '/consumer';

// export const login = async (data) => {
//     const response = await axios.post('/auth/login', data);
//     const { success, message, data: tokenData } = response.data;

//     if (success && tokenData?.token) {
//         localStorage.setItem('Token', tokenData.token);
//         return tokenData;
//     } else {
//         throw new Error(message || 'Login failed');
//     }
// };

// export const getConsumers = async (page = 1, limit = 10) => {
//     const response = await axios.get(`${BASE_URL}?page=${page}&limit=${limit}`);
//     const { success, message, data } = response.data;

//     if (success) {
//         return data; // contains consumers, currentPage, totalItems, totalPages
//     } else {
//         throw new Error(message || 'Failed to fetch consumers');
//     }
// };

// export const registerConsumer = async (data) => {
//     const formData = new FormData();
//     for (const key in data) {
//         formData.append(key, data[key]);
//     }

//     const response = await axios.post(`${BASE_URL}/register`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//     });

//     const { success, message, data: resultData } = response.data;
//     if (success) {
//         return resultData;
//     } else {
//         throw new Error(message || 'Registration failed');
//     }
// };

// export const updateConsumer = async (id, data) => {
//     const formData = new FormData();
//     for (const key in data) {
//         formData.append(key, data[key]);
//     }

//     const response = await axios.put(`${BASE_URL}/update/${id}`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//     });

//     const { success, message, data: resultData } = response.data;
//     if (success) {
//         return resultData;
//     } else {
//         throw new Error(message || 'Update failed');
//     }
// };

// export const deleteConsumer = async (id, data) => {
//     const response = await axios.delete(`${BASE_URL}/delete/${id}`, { data });

//     const { success, message, data: resultData } = response.data;
//     if (success) {
//         return resultData;
//     } else {
//         throw new Error(message || 'Delete failed');
//     }
// };

// export const resetPassword = async (payload) => {
//     const response = await axios.post(`/user/reset-password`, payload);
//     const { success, message, data: resultData } = response.data;

//     if (success) {
//         return resultData;
//     } else {
//         throw new Error(message || 'Reset password failed');
//     }
// };

// export const openConsumerPdf = async (id, type) => {
//     try {
//         const response = await axios.get(`${BASE_URL}/pdf/${id}?type=${type}`, {
//             responseType: 'blob',
//         });

//         const contentDisposition = response.headers['content-disposition'];
//         let filename = 'Document.pdf';
//         if (contentDisposition) {
//             const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//             if (match && match[1]) {
//                 filename = match[1].replace(/['"]/g, '');
//             }
//         }

//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         const url = window.URL.createObjectURL(blob);

//         const link = document.createElement('a');
//         link.href = url;
//         link.download = filename;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error('Error downloading PDF:', error.message || error);
//         throw new Error('Failed to download PDF');
//     }
// };
